import type {
  Api,
  Endpoint,
  Entity,
  Property,
  Webhook,
} from '@square/ignition';

function isWebhookObject(object: Entity): boolean {
  return (
    object.name.endsWith('EventData') || object.name.endsWith('EventObject')
  );
}

function isValidObject<T extends Endpoint | Property | Entity | Webhook>(
  object: T
): boolean {
  return (
    !object.isDeprecated && !object.isRetired && !(object as Endpoint).isV1
  );
}

function filterForValidGraphObjects<
  T extends Endpoint | Property | Entity | Webhook
>(objects?: T[]): T[] {
  return objects?.filter(isValidObject) || [];
}

function filterForValidV1GraphObjects<
  T extends Endpoint | Property | Entity | Webhook
>(objects?: T[]): T[] {
  return (
    objects?.filter(
      (object) =>
        !object.isDeprecated && !object.isRetired && (object as Endpoint).isV1
    ) || []
  );
}

function filterForDeprecatedGraphObjects<
  T extends Endpoint | Property | Entity | Webhook
>(objects?: T[]): T[] {
  return objects?.filter((object) => object.isDeprecated) || [];
}

function filterForValidGraphEntityObjects(objects?: Entity[]): Entity[] {
  return filterForValidGraphObjects(objects).filter(
    (entity) => entity.isIndependent
  );
}

function filterForValidGraphEnums(objects?: Entity[]): Entity[] {
  return filterForValidGraphObjects(objects).filter((entity) => entity.isEnum);
}

function filterForValidApis(apis?: Api[]): Api[] {
  return (
    apis?.filter((api) => {
      return api.endpoints?.some((endpoint) => isValidObject(endpoint));
    }) || []
  );
}

function filterForValidApiExplorerEndpoints(endpoints: Endpoint[]): Endpoint[] {
  return (
    endpoints?.filter(
      (endpoint) =>
        !endpoint.isDocsOnly &&
        !endpoint.isRetired &&
        !endpoint.isV1 &&
        !endpoint.isDeprecated
    ) || []
  );
}

export {
  isWebhookObject,
  filterForValidGraphObjects,
  filterForDeprecatedGraphObjects,
  filterForValidV1GraphObjects,
  filterForValidGraphEntityObjects,
  filterForValidGraphEnums,
  filterForValidApis,
  filterForValidApiExplorerEndpoints,
};
